const SUBSCRIPTION_ACTION = {
  IS_SUBSCRIPTION: 'IS_SUBSCRIPTION',
  SUBSCRIPTION_SUCCESS: 'SUBSCRIPTION_SUCCESS',
  SUBSCRIPTION_ERROR: 'SUBSCRIPTION_ERROR',
};

export default SUBSCRIPTION_ACTION;
